import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { Adg4Skeleton } from '@/components/adg4/skeleton/src/skeleton';

const headingSectionGap = css({
	marginBlockEnd: token('space.1000'),
});

const sectionGap = css({
	marginBlockEnd: token('space.800'),
	[media.below.md]: {
		marginBlockEnd: token('space.800'),
	},
});

const contianerStyles = css({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
});

const mobileDisplay = css({
	display: 'none',
	[media.below.md]: {
		display: 'block',
	},
});

const desktopDisplay = css({
	display: 'block',
	[media.below.md]: {
		display: 'none',
	},
});

export const LoggedInHeroSkeleton = () => {
	return (
		<div
			data-testid="logged-in-jira-pt-skeleton"
			css={css({ marginBlockStart: token('space.300') })}
		>
			<div css={desktopDisplay}>
				<div css={contianerStyles}>
					<div css={[headingSectionGap]}>
						<Adg4Skeleton width="1152px" height="48px" />
					</div>
					<div css={sectionGap}>
						<Adg4Skeleton width="1140px" height="1140px" />
					</div>
				</div>
			</div>
			<div css={mobileDisplay}>
				<div css={contianerStyles}>
					<div css={[headingSectionGap]}>
						<Adg4Skeleton width="480px" height="48px" />
					</div>
					<div css={sectionGap}>
						<Adg4Skeleton width="480px" height="480px" />
					</div>
				</div>
			</div>
		</div>
	);
};
